export default "/images/vendor/flag-icon-css/flags/4x3/nl.svg?21eb77dcfa38c6d7bb81fb3d3ab4a7cf";